// Helper to read content from Auxo CMS public API endpoints.
// All requests are relative to current origin (Rule 11b).

export async function getCmsContent(collectionName) {
  try {
    const res = await fetch(`/_api/public/content/${collectionName}`);
    if (!res.ok) {
      console.warn(`CMS fetch failed for ${collectionName}: ${res.status}`);
      return [];
    }
    const data = await res.json();
    return Array.isArray(data) ? data : data?.items || [];
  } catch (err) {
    console.warn(`CMS network error for ${collectionName}:`, err);
    return [];
  }
}

export async function getCmsEntryBySlug(collectionName, slug) {
  try {
    const items = await getCmsContent(collectionName);
    return items.find((item) => {
      const s = typeof item.slug === 'object' ? item.slug._ || Object.values(item.slug)[0] : item.slug;
      return s === slug;
    }) || null;
  } catch (err) {
    console.warn(`CMS getBySlug error for ${collectionName}/${slug}:`, err);
    return null;
  }
}
